import { useStore, useStoreMap } from 'effector-react'
import { balanceModel } from '~/entities/Balance'
import { PayCardAttributes } from '~/shared/api'
import { EmptyList } from '~/shared/ui/BalanceList'
import { Button } from '~/shared/ui/Buttons'
import { TrashIcon } from '~/shared/ui/icons'
import { PayCardContent, PayCardWrapper } from '~/shared/ui/PayCard'
import { Radio, RadioGroup } from '~/shared/ui/Radio'
import { SkeletonList } from '~/shared/ui/SkeletonList'
import { WrapperCard } from './styled'
import { AddCardButton } from './ui/AddCardButton'
import { DeleteCardDrawer } from './ui/DeleteCardDrawer'

export function ListBankCards() {
  const isPayCardsPending = useStore(balanceModel.getPayCardsFx.pending)
  const isPayCardDeleting = useStore(balanceModel.payCardRemoveFx.pending)

  const payCards = useStoreMap(balanceModel.$payCards, (payCards) =>
    payCards?.map((payCard) => payCard.getAttributes()),
  )
  const selectedPayCard = useStoreMap(
    balanceModel.$selectedPayCard,
    (payCard) => payCard?.getAttributes(),
  )
  const isDrawerShow = useStoreMap(
    balanceModel.$payCardAttributesForDeleting,
    (payCard) => Boolean(payCard),
  )

  const handleChangeSelectedPayCard = (bankCardId: UniqueId) => {
    balanceModel.changeSelectedPayCard(bankCardId)
  }

  const handleDeleteDrawerOpen = (payCard: PayCardAttributes) => {
    balanceModel.deleteCardDrawerOpen(payCard)
  }

  if (isPayCardsPending)
    return (
      <SkeletonList count={6} skeletonHeight={56} itemMarginBottom='16px' />
    )

  return (
    <div>
      {!payCards?.length && (
        <EmptyList
          title='У вас еще не добавлены банковские карты'
          description='Здесь будет отображаться список банковских карт'
        />
      )}
      <RadioGroup
        value={selectedPayCard?.bankCardId || ''}
        onChange={(bankCardId) => handleChangeSelectedPayCard(bankCardId)}
        name='bank-cards-group'
      >
        {(payCards || []).map((card) => (
          <WrapperCard key={card.bankCardId}>
            <PayCardWrapper>
              <Radio
                checked={card.bankCardId === selectedPayCard?.bankCardId}
                value={card.bankCardId}
              />

              <PayCardContent cardNumber={card.maskedNumber} />

              <Button
                data-testid={`delete-bank-card-${card.maskedNumber}`}
                onClick={() => handleDeleteDrawerOpen(card)}
                variant='textLink'
              >
                <TrashIcon />
              </Button>
            </PayCardWrapper>
          </WrapperCard>
        ))}
      </RadioGroup>

      <AddCardButton />

      <DeleteCardDrawer
        isLoading={isPayCardDeleting}
        isShow={isDrawerShow}
        onClose={balanceModel.deleteCardDrawerClose}
        onDelete={balanceModel.payCardRemove}
      />
    </div>
  )
}
